<template>
    <PageBase class="content-background-forms">
        <home-header v-if="isJACareerApp && ($route.name == 'js_start_project' || $route.name == 'js_edit_project')" />
        <template v-slot:navigation>
            <JSNavigation />
        </template>
        <router-view></router-view>
    </PageBase>
</template>

<script>
    import PageBase from '../../../core/Components/PageBase.vue'
    import JSNavigation from '../Components/JSNavigation.vue'
    import HomeHeader from '../../Home/Components/HomeHeader'

    export default {
        name: "FormPage",
        components: {
            PageBase,
            JSNavigation,
            HomeHeader
        }
    }
</script>

<style lang="stylus" scoped>
    @import "~@/core/Styles/variables.styl"
    @import "~@/core/Styles/mixins.styl"
    .content-background-forms
         background-color color-1
    +for_breakpoint(xs)
        .content-background-forms
            background-image linear-gradient(color-1 0%, color-1 50%, white 60%, white 100%)
</style>
